var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"joystick-wrapper"},[_c('JoyStick',{attrs:{"isCircular":_vm.block.circular,"debug":_vm.$parent.ShowDebugger},on:{"leverchange":function($event){return _vm.UpdateLever($event)},"touchStart":_vm.TouchStarted,"touchFinish":_vm.TouchFinished}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }